import impressum from '../../../../../../docs/legal/impressum.md?raw';
import { LEGAL_PLACEHOLDER } from './legalPlaceholder';

/**
 * Das Impressum für Flächen außerhalb des Gastportals. Eigenes Modul, damit die Anmeldung nicht
 * alle Rechtstexte des Gastportals ins Admin-Bundle zieht.
 */
export const IMPRINT = impressum;

export const imprintPublishable = !LEGAL_PLACEHOLDER.test(impressum);
